// // import React, { useEffect, useState, useContext } from 'react';
// // import { Command } from 'cmdk';
// // import { useNavigate } from 'react-router-dom';
// // import { AuthContext } from '../context/AuthContext';
// // import * as Dialog from '@radix-ui/react-dialog'; 

// // const CommandMenu = () => {
// //   const [open, setOpen] = useState(false);
// //   const navigate = useNavigate();
// //   const { user } = useContext(AuthContext);

// //   // Keyboard Shortcut (Ctrl + Space)
// //   useEffect(() => {
// //     const down = (e) => {
// //       if (e.key === ' ' && (e.metaKey || e.ctrlKey)) {
// //         e.preventDefault();
// //         setOpen((open) => !open);
// //       }
// //     };
// //     document.addEventListener('keydown', down);
// //     return () => document.removeEventListener('keydown', down);
// //   }, []);

// //   // Custom Event Listener Navbar button ke liye
// //   useEffect(() => {
// //     const openMenu = () => setOpen(true);
// //     window.addEventListener('open-command-menu', openMenu);
// //     return () => window.removeEventListener('open-command-menu', openMenu);
// //   }, []);

// //   const handleSelect = (path) => {
// //     navigate(path);
// //     setOpen(false);
// //   };

// //   return (
// //     <Command.Dialog 
// //       open={open} 
// //       onOpenChange={setOpen} 
// //       className="fixed inset-0 z-[99999] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm"
// //     >
// //       <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl overflow-hidden w-full max-w-2xl border border-gray-200 dark:border-gray-700 animate-in fade-in zoom-in-95 duration-200">
        
// //         <Dialog.Title className="sr-only">Global Search Menu</Dialog.Title>
// //         <Dialog.Description className="sr-only">Search and navigate through LMS dashboard modules.</Dialog.Description>

// //         <Command.Input 
// //           placeholder={`Search modules, chats, tasks... (e.g., 'leads', 'whatsapp')`} 
// //           className="w-full p-4 border-b border-gray-200 dark:border-gray-700 bg-transparent text-gray-900 dark:text-white outline-none text-lg font-medium"
// //         />

// //         <Command.List className="p-2 max-h-[65vh] overflow-y-auto scrollbar-thin">
// //           <Command.Empty className="p-8 text-sm text-gray-500 text-center">No results found.</Command.Empty>

// //           {/* 1. CORE OPERATIONS */}
// //           <Command.Group heading="Core Modules" className="text-xs text-indigo-500 dark:text-indigo-400 uppercase font-bold px-2 py-2">
// //             <Command.Item onSelect={() => handleSelect('/dashboard')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
// //               <span>📊 Dashboard Home</span>
// //               <span className="text-xs text-gray-400 font-normal">/dashboard</span>
// //             </Command.Item>
// //             <Command.Item onSelect={() => handleSelect('/lead/lead')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
// //               <span>👥 Manage Leads</span>
// //               <span className="text-xs text-gray-400 font-normal">/lead/lead</span>
// //             </Command.Item>
// //             <Command.Item onSelect={() => handleSelect('/customer')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
// //               <span>🏢 View Customers</span>
// //               <span className="text-xs text-gray-400 font-normal">/customer</span>
// //             </Command.Item>
// //             <Command.Item onSelect={() => handleSelect('/lead/lead/report')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
// //               <span>📈 Today's Lead Report</span>
// //               <span className="text-xs text-gray-400 font-normal">report</span>
// //             </Command.Item>
// //           </Command.Group>

// //           {/* 2. PRODUCTIVITY & TASKS */}
// //           <Command.Group heading="Productivity & Tracking" className="text-xs text-emerald-500 dark:text-emerald-400 uppercase font-bold px-2 py-2 border-t border-gray-100 dark:border-gray-700 mt-2">
// //             <Command.Item onSelect={() => handleSelect('/tasks')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
// //               <span>✅ General Tasks</span>
// //               <span className="text-xs text-gray-400 font-normal">/tasks</span>
// //             </Command.Item>
// //             <Command.Item onSelect={() => handleSelect('/lead-tasks')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
// //               <span>🎯 Lead Specific Tasks</span>
// //               <span className="text-xs text-gray-400 font-normal">/lead-tasks</span>
// //             </Command.Item>
// //             <Command.Item onSelect={() => handleSelect('/issues')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
// //               <span>⚠️ Technical Issues</span>
// //               <span className="text-xs text-gray-400 font-normal">/issues</span>
// //             </Command.Item>
// //             <Command.Item onSelect={() => handleSelect('/todo')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
// //               <span>📝 Personal To-Do List</span>
// //               <span className="text-xs text-gray-400 font-normal">/todo</span>
// //             </Command.Item>
// //             <Command.Item onSelect={() => handleSelect('/calendar')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
// //               <span>📅 Event Calendar</span>
// //               <span className="text-xs text-gray-400 font-normal">/calendar</span>
// //             </Command.Item>
// //             <Command.Item onSelect={() => handleSelect('/meeting')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
// //               <span>🤝 Schedule Meetings</span>
// //               <span className="text-xs text-gray-400 font-normal">/meeting</span>
// //             </Command.Item>
// //           </Command.Group>

// //           {/* 3. CHAT & WHATSAPP ENGINE */}
// //           <Command.Group heading="Communications & Messaging" className="text-xs text-teal-500 dark:text-teal-400 uppercase font-bold px-2 py-2 border-t border-gray-100 dark:border-gray-700 mt-2">
// //             <Command.Item onSelect={() => handleSelect('/chat')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
// //               <span>💬 Live Chat Room</span>
// //               <span className="text-xs text-gray-400 font-normal">/chat</span>
// //             </Command.Item>
// //             <Command.Item onSelect={() => handleSelect('/whatsappSms')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
// //               <span>🟢 WhatsApp Bulk SMS</span>
// //               <span className="text-xs text-gray-400 font-normal">/whatsappSms</span>
// //             </Command.Item>
// //             <Command.Item onSelect={() => handleSelect('/auto-reply')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
// //               <span>🤖 WhatsApp Auto Reply Rules</span>
// //               <span className="text-xs text-gray-400 font-normal">/auto-reply</span>
// //             </Command.Item>
// //             <Command.Item onSelect={() => handleSelect('/whatsappReport')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
// //               <span>📊 WhatsApp Delivery Reports</span>
// //               <span className="text-xs text-gray-400 font-normal">/whatsappReport</span>
// //             </Command.Item>
// //             <Command.Item onSelect={() => handleSelect('/createWhatsappTemplate')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
// //               <span>✨ Create WhatsApp Template</span>
// //               <span className="text-xs text-gray-400 font-normal">template</span>
// //             </Command.Item>
// //           </Command.Group>

// //           {/* 4. HR & ATTENDANCE */}
// //           <Command.Group heading="HR & Attendance" className="text-xs text-amber-500 dark:text-amber-400 uppercase font-bold px-2 py-2 border-t border-gray-100 dark:border-gray-700 mt-2">
// //             <Command.Item onSelect={() => handleSelect('/attendance')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
// //               <span>📅 Attendance Log</span>
// //               <span className="text-xs text-gray-400 font-normal">/attendance</span>
// //             </Command.Item>
// //             <Command.Item onSelect={() => handleSelect('/leave')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
// //               <span>🚪 Leave Management</span>
// //               <span className="text-xs text-gray-400 font-normal">/leave</span>
// //             </Command.Item>
// //             <Command.Item onSelect={() => handleSelect('/workingPolicy')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
// //               <span>📜 Company Working Policy</span>
// //               <span className="text-xs text-gray-400 font-normal">/workingPolicy</span>
// //             </Command.Item>
// //           </Command.Group>

// //           {/* 5. ACCOUNTS & INVOICES */}
// //           <Command.Group heading="Accounts & Billing" className="text-xs text-rose-500 dark:text-rose-400 uppercase font-bold px-2 py-2 border-t border-gray-100 dark:border-gray-700 mt-2">
// //             <Command.Item onSelect={() => handleSelect('/invoice')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
// //               <span>🧾 Generate Invoices</span>
// //               <span className="text-xs text-gray-400 font-normal">/invoice</span>
// //             </Command.Item>
// //             <Command.Item onSelect={() => handleSelect('/accountStatement')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
// //               <span>💳 Account Statements</span>
// //               <span className="text-xs text-gray-400 font-normal">/accountStatement</span>
// //             </Command.Item>
// //             <Command.Item onSelect={() => handleSelect('/viewAccount')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
// //               <span>🏢 View Sub-Accounts</span>
// //               <span className="text-xs text-gray-400 font-normal">/viewAccount</span>
// //             </Command.Item>
// //           </Command.Group>

// //           {/* 6. SYSTEM SETTINGS & INTEGRATIONS */}
// //           <Command.Group heading="Settings & Integrations" className="text-xs text-gray-400 uppercase font-bold px-2 py-2 border-t border-gray-100 dark:border-gray-700 mt-2">
// //             <Command.Item onSelect={() => handleSelect('/profile')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
// //               <span>⚙️ Profile Settings</span>
// //               <span className="text-xs text-gray-400 font-normal">/profile</span>
// //             </Command.Item>
// //             <Command.Item onSelect={() => handleSelect('/whatsappConfig')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
// //               <span>🔧 WhatsApp API Integration</span>
// //               <span className="text-xs text-gray-400 font-normal">/whatsappConfig</span>
// //             </Command.Item>
// //             <Command.Item onSelect={() => handleSelect('/smsConfig')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
// //               <span>💬 Bulk SMS Configuration</span>
// //               <span className="text-xs text-gray-400 font-normal">/smsConfig</span>
// //             </Command.Item>
// //             <Command.Item onSelect={() => handleSelect('/ivrIntegration')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
// //               <span>📞 IVR Calling Integration</span>
// //               <span className="text-xs text-gray-400 font-normal">/ivrIntegration</span>
// //             </Command.Item>
// //             <Command.Item onSelect={() => handleSelect('/facebookIntegration')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
// //               <span>🔵 Facebook Lead Ads Sync</span>
// //               <span className="text-xs text-gray-400 font-normal">/facebookIntegration</span>
// //             </Command.Item>
// //             <Command.Item onSelect={() => handleSelect('/googleForm')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
// //               <span>📝 Google Form Integration</span>
// //               <span className="text-xs text-gray-400 font-normal">/googleForm</span>
// //             </Command.Item>
// //             <Command.Item onSelect={() => handleSelect('/webSetting')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
// //               <span>🌐 Web CRM Custom Settings</span>
// //               <span className="text-xs text-gray-400 font-normal">/webSetting</span>
// //             </Command.Item>
// //           </Command.Group>
// //         </Command.List>

// //       </div>
// //     </Command.Dialog>
// //   );
// // };

// // export default CommandMenu;




// import React, { useEffect, useState, useContext } from 'react';
// import { Command } from 'cmdk';
// import { useNavigate } from 'react-router-dom';
// import { AuthContext } from '../context/AuthContext';
// import * as Dialog from '@radix-ui/react-dialog'; 

// const CommandMenu = () => {
//   const [open, setOpen] = useState(false);
//   const navigate = useNavigate();
//   const { user } = useContext(AuthContext);

//   // Keyboard Shortcut (Ctrl + Space)
//   useEffect(() => {
//     const down = (e) => {
//       if (e.key === ' ' && (e.metaKey || e.ctrlKey)) {
//         e.preventDefault();
//         setOpen((open) => !open);
//       }
//     };
//     document.addEventListener('keydown', down);
//     return () => document.removeEventListener('keydown', down);
//   }, []);

//   // Custom Event Listener Navbar button ke liye
//   useEffect(() => {
//     const openMenu = () => setOpen(true);
//     window.addEventListener('open-command-menu', openMenu);
//     return () => window.removeEventListener('open-command-menu', openMenu);
//   }, []);

//   const handleSelect = (path) => {
//     navigate(path);
//     setOpen(false);
//   };

//   return (
//     <Command.Dialog 
//       open={open} 
//       onOpenChange={setOpen} 
//       className="fixed inset-0 z-[99999] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm"
//     >
//       <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl overflow-hidden w-full max-w-2xl border border-gray-200 dark:border-gray-700 animate-in fade-in zoom-in-95 duration-200">
        
//         <Dialog.Title className="sr-only">Global Search Menu</Dialog.Title>
//         <Dialog.Description className="sr-only">Search and navigate through LMS dashboard modules.</Dialog.Description>

//         {/* Input & Close Button Wrapper */}
//         <div className="relative w-full">
//           <Command.Input 
//             placeholder={`Search modules, chats, tasks... (e.g., 'leads', 'whatsapp')`} 
//             className="w-full p-4 pr-12 border-b border-gray-200 dark:border-gray-700 bg-transparent text-gray-900 dark:text-white outline-none text-lg font-medium"
//           />
//           <button
//             onClick={() => setOpen(false)}
//             className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 text-xl transition"
//             aria-label="Close menu"
//           >
//             ✕
//           </button>
//         </div>

//         <Command.List className="p-2 max-h-[65vh] overflow-y-auto scrollbar-thin">
//           <Command.Empty className="p-8 text-sm text-gray-500 text-center">No results found.</Command.Empty>

//           {/* 1. CORE OPERATIONS */}
//           <Command.Group heading="Core Modules" className="text-xs text-indigo-500 dark:text-indigo-400 uppercase font-bold px-2 py-2">
//             <Command.Item onSelect={() => handleSelect('/dashboard')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
//               <span>📊 Dashboard Home</span>
//               <span className="text-xs text-gray-400 font-normal">/dashboard</span>
//             </Command.Item>
//             <Command.Item onSelect={() => handleSelect('/lead/lead')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
//               <span>👥 Manage Leads</span>
//               <span className="text-xs text-gray-400 font-normal">/lead/lead</span>
//             </Command.Item>
//             <Command.Item onSelect={() => handleSelect('/customer')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
//               <span>🏢 View Customers</span>
//               <span className="text-xs text-gray-400 font-normal">/customer</span>
//             </Command.Item>
//             <Command.Item onSelect={() => handleSelect('/lead/lead/report')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
//               <span>📈 Today's Lead Report</span>
//               <span className="text-xs text-gray-400 font-normal">report</span>
//             </Command.Item>
//           </Command.Group>

//           {/* 2. PRODUCTIVITY & TASKS */}
//           <Command.Group heading="Productivity & Tracking" className="text-xs text-emerald-500 dark:text-emerald-400 uppercase font-bold px-2 py-2 border-t border-gray-100 dark:border-gray-700 mt-2">
//             <Command.Item onSelect={() => handleSelect('/tasks')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
//               <span>✅ General Tasks</span>
//               <span className="text-xs text-gray-400 font-normal">/tasks</span>
//             </Command.Item>
//             <Command.Item onSelect={() => handleSelect('/lead-tasks')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
//               <span>🎯 Lead Specific Tasks</span>
//               <span className="text-xs text-gray-400 font-normal">/lead-tasks</span>
//             </Command.Item>
//             <Command.Item onSelect={() => handleSelect('/issues')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
//               <span>⚠️ Technical Issues</span>
//               <span className="text-xs text-gray-400 font-normal">/issues</span>
//             </Command.Item>
//             <Command.Item onSelect={() => handleSelect('/todo')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
//               <span>📝 Personal To-Do List</span>
//               <span className="text-xs text-gray-400 font-normal">/todo</span>
//             </Command.Item>
//             <Command.Item onSelect={() => handleSelect('/calendar')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
//               <span>📅 Event Calendar</span>
//               <span className="text-xs text-gray-400 font-normal">/calendar</span>
//             </Command.Item>
//             <Command.Item onSelect={() => handleSelect('/meeting')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
//               <span>🤝 Schedule Meetings</span>
//               <span className="text-xs text-gray-400 font-normal">/meeting</span>
//             </Command.Item>
//           </Command.Group>

//           {/* 3. CHAT & WHATSAPP ENGINE */}
//           <Command.Group heading="Communications & Messaging" className="text-xs text-teal-500 dark:text-teal-400 uppercase font-bold px-2 py-2 border-t border-gray-100 dark:border-gray-700 mt-2">
//             <Command.Item onSelect={() => handleSelect('/chat')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
//               <span>💬 Live Chat Room</span>
//               <span className="text-xs text-gray-400 font-normal">/chat</span>
//             </Command.Item>
//             <Command.Item onSelect={() => handleSelect('/whatsappSms')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
//               <span>🟢 WhatsApp Bulk SMS</span>
//               <span className="text-xs text-gray-400 font-normal">/whatsappSms</span>
//             </Command.Item>
//             <Command.Item onSelect={() => handleSelect('/auto-reply')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
//               <span>🤖 WhatsApp Auto Reply Rules</span>
//               <span className="text-xs text-gray-400 font-normal">/auto-reply</span>
//             </Command.Item>
//             <Command.Item onSelect={() => handleSelect('/whatsappReport')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
//               <span>📊 WhatsApp Delivery Reports</span>
//               <span className="text-xs text-gray-400 font-normal">/whatsappReport</span>
//             </Command.Item>
//             <Command.Item onSelect={() => handleSelect('/createWhatsappTemplate')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
//               <span>✨ Create WhatsApp Template</span>
//               <span className="text-xs text-gray-400 font-normal">template</span>
//             </Command.Item>
//           </Command.Group>

//           {/* 4. HR & ATTENDANCE */}
//           <Command.Group heading="HR & Attendance" className="text-xs text-amber-500 dark:text-amber-400 uppercase font-bold px-2 py-2 border-t border-gray-100 dark:border-gray-700 mt-2">
//             <Command.Item onSelect={() => handleSelect('/attendance')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
//               <span>📅 Attendance Log</span>
//               <span className="text-xs text-gray-400 font-normal">/attendance</span>
//             </Command.Item>
//             <Command.Item onSelect={() => handleSelect('/leave')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
//               <span>🚪 Leave Management</span>
//               <span className="text-xs text-gray-400 font-normal">/leave</span>
//             </Command.Item>
//             <Command.Item onSelect={() => handleSelect('/workingPolicy')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
//               <span>📜 Company Working Policy</span>
//               <span className="text-xs text-gray-400 font-normal">/workingPolicy</span>
//             </Command.Item>
//           </Command.Group>

//           {/* 5. ACCOUNTS & INVOICES */}
//           <Command.Group heading="Accounts & Billing" className="text-xs text-rose-500 dark:text-rose-400 uppercase font-bold px-2 py-2 border-t border-gray-100 dark:border-gray-700 mt-2">
//             <Command.Item onSelect={() => handleSelect('/invoice')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
//               <span>🧾 Generate Invoices</span>
//               <span className="text-xs text-gray-400 font-normal">/invoice</span>
//             </Command.Item>
//             <Command.Item onSelect={() => handleSelect('/accountStatement')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
//               <span>💳 Account Statements</span>
//               <span className="text-xs text-gray-400 font-normal">/accountStatement</span>
//             </Command.Item>
//             <Command.Item onSelect={() => handleSelect('/viewAccount')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
//               <span>🏢 View Sub-Accounts</span>
//               <span className="text-xs text-gray-400 font-normal">/viewAccount</span>
//             </Command.Item>
//           </Command.Group>

//           {/* 6. SYSTEM SETTINGS & INTEGRATIONS */}
//           <Command.Group heading="Settings & Integrations" className="text-xs text-gray-400 uppercase font-bold px-2 py-2 border-t border-gray-100 dark:border-gray-700 mt-2">
//             <Command.Item onSelect={() => handleSelect('/profile')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
//               <span>⚙️ Profile Settings</span>
//               <span className="text-xs text-gray-400 font-normal">/profile</span>
//             </Command.Item>
//             <Command.Item onSelect={() => handleSelect('/whatsappConfig')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
//               <span>🔧 WhatsApp API Integration</span>
//               <span className="text-xs text-gray-400 font-normal">/whatsappConfig</span>
//             </Command.Item>
//             <Command.Item onSelect={() => handleSelect('/smsConfig')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
//               <span>💬 Bulk SMS Configuration</span>
//               <span className="text-xs text-gray-400 font-normal">/smsConfig</span>
//             </Command.Item>
//             <Command.Item onSelect={() => handleSelect('/ivrIntegration')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
//               <span>📞 IVR Calling Integration</span>
//               <span className="text-xs text-gray-400 font-normal">/ivrIntegration</span>
//             </Command.Item>
//             <Command.Item onSelect={() => handleSelect('/facebookIntegration')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
//               <span>🔵 Facebook Lead Ads Sync</span>
//               <span className="text-xs text-gray-400 font-normal">/facebookIntegration</span>
//             </Command.Item>
//             <Command.Item onSelect={() => handleSelect('/googleForm')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
//               <span>📝 Google Form Integration</span>
//               <span className="text-xs text-gray-400 font-normal">/googleForm</span>
//             </Command.Item>
//             <Command.Item onSelect={() => handleSelect('/webSetting')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
//               <span>🌐 Web CRM Custom Settings</span>
//               <span className="text-xs text-gray-400 font-normal">/webSetting</span>
//             </Command.Item>
//           </Command.Group>
//         </Command.List>

//       </div>
//     </Command.Dialog>
//   );
// };

// export default CommandMenu;



import React, { useEffect, useState, useContext } from 'react';
import { Command } from 'cmdk';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import * as Dialog from '@radix-ui/react-dialog';
import axios from 'axios';
import { API_URL } from '../../Constants';

const CommandMenu = () => {
  const [open, setOpen] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [leads, setLeads] = useState([]);
  const [isSearching, setIsSearching] = useState(false);

  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  const companyId = user?.accountType === "COMPANY" ? user?.id : user?.companyId;
  const token = user?.token || localStorage.getItem("token");

  // Keyboard Shortcut (Ctrl + Space)
  useEffect(() => {
    const down = (e) => {
      if (e.key === ' ' && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        setOpen((open) => !open);
      }
    };
    document.addEventListener('keydown', down);
    return () => document.removeEventListener('keydown', down);
  }, []);

  // Custom Event Listener Navbar button ke liye
  useEffect(() => {
    const openMenu = () => setOpen(true);
    window.addEventListener('open-command-menu', openMenu);
    return () => window.removeEventListener('open-command-menu', openMenu);
  }, []);

  // Debounced API call for searching leads
  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      const keyword = inputValue.trim();
      
      if (!keyword || !companyId) {
        setLeads([]);
        setIsSearching(false);
        return;
      }

      // Auto-detect search type: if it contains letters, search by name, else phone
      const hasLetters = /[a-zA-Z]/.test(keyword);
      const searchType = hasLetters ? "name" : "phone";

      setIsSearching(true);
      try {
        const res = await axios.get(`${API_URL}/api/leads/search/${companyId}/${user?.id}`, {
          params: { [searchType]: keyword, limit: 10 },
          headers: { Authorization: `Bearer ${token}` }
        });
        
        const fetchedLeads = res.data?.leads || (Array.isArray(res.data) ? res.data : []);
        const leadsArray = Array.isArray(fetchedLeads) ? fetchedLeads : (fetchedLeads.content || []);
        
        setLeads(leadsArray);
      } catch (error) {
        console.error("CommandMenu lead search error:", error);
        setLeads([]);
      } finally {
        setIsSearching(false);
      }
    }, 400); // 400ms debounce

    return () => clearTimeout(delayDebounceFn);
  }, [inputValue, companyId, user?.id, token]);

  const handleSelect = (path) => {
    navigate(path);
    closeMenu();
  };

  const handleSelectLead = (lead) => {
    // Redirects to Recently Leads page and opens the specific lead
    navigate('/dashboard/recentleads', { state: { mode: 'single', lead } });
    closeMenu();
  };

  const closeMenu = () => {
    setOpen(false);
    setInputValue('');
    setLeads([]);
  };

  return (
    <Command.Dialog 
      open={open} 
      onOpenChange={(isOpen) => {
        setOpen(isOpen);
        if (!isOpen) closeMenu();
      }} 
      className="fixed inset-0 z-[99999] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm"
    >
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl overflow-hidden w-full max-w-2xl border border-gray-200 dark:border-gray-700 animate-in fade-in zoom-in-95 duration-200">
        
        <Dialog.Title className="sr-only">Global Search Menu</Dialog.Title>
        <Dialog.Description className="sr-only">Search and navigate through LMS dashboard modules or find leads.</Dialog.Description>

        {/* Input & Close Button Wrapper */}
        <div className="relative w-full">
          <Command.Input 
            value={inputValue}
            onValueChange={setInputValue}
            placeholder={`Search modules, chats, tasks... or find a lead (name/phone)`} 
            className="w-full p-4 pr-12 border-b border-gray-200 dark:border-gray-700 bg-transparent text-gray-900 dark:text-white outline-none text-lg font-medium"
          />
          {isSearching && (
             <div className="absolute right-12 top-1/2 -translate-y-1/2 pointer-events-none">
                <div className="w-5 h-5 border-2 border-[#673AB7] border-t-transparent rounded-full animate-spin"></div>
             </div>
          )}
          <button
            onClick={closeMenu}
            className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 text-xl transition"
            aria-label="Close menu"
          >
            ✕
          </button>
        </div>

        <Command.List className="p-2 max-h-[65vh] overflow-y-auto scrollbar-thin">
          <Command.Empty className="p-8 text-sm text-gray-500 text-center">
            {isSearching ? 'Searching...' : 'No results found.'}
          </Command.Empty>

          {/* DYNAMIC LEADS SEARCH RESULTS */}
          {(leads.length > 0) && (
            <Command.Group heading="🔍 Found Leads" className="text-xs text-[#673AB7] dark:text-purple-400 uppercase font-bold px-2 py-2 mb-2">
              {leads.map(lead => (
                <Command.Item 
                  key={lead.leadId}
                  // value ensures cmdk doesn't filter out the api results 
                  value={`${lead.name} ${lead.phone} ${lead.companyName || ''} ${lead.leadId}`}
                  onSelect={() => handleSelectLead(lead)} 
                  className="p-3 mb-1 cursor-pointer hover:bg-purple-50 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors border border-transparent hover:border-purple-100 dark:hover:border-gray-600"
                >
                  <div className="flex flex-col flex-1 min-w-0 pr-4">
                    <span className="font-semibold text-[14px] truncate">{lead.name}</span>
                    <span className="text-[11px] text-gray-500 dark:text-gray-400 truncate mt-0.5">
                      📞 {lead.phone} {lead.companyName ? ` • 🏢 ${lead.companyName}` : ''}
                    </span>
                  </div>
                  <span 
                    className="text-[10px] font-bold px-2.5 py-1 rounded-full text-white shadow-sm shrink-0 whitespace-nowrap" 
                    style={{ backgroundColor: lead.statusColor || '#0C4550' }}
                  >
                    {lead.statusName || 'New'}
                  </span>
                </Command.Item>
              ))}
            </Command.Group>
          )}

          {/* 1. CORE OPERATIONS */}
          <Command.Group heading="Core Modules" className={`text-xs text-indigo-500 dark:text-indigo-400 uppercase font-bold px-2 py-2 ${leads.length > 0 ? 'border-t border-gray-100 dark:border-gray-700' : ''}`}>
            <Command.Item onSelect={() => handleSelect('/dashboard')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
              <span>📊 Dashboard Home</span>
              <span className="text-xs text-gray-400 font-normal">/dashboard</span>
            </Command.Item>
            <Command.Item onSelect={() => handleSelect('/lead/lead')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
              <span>👥 Manage Leads</span>
              <span className="text-xs text-gray-400 font-normal">/lead/lead</span>
            </Command.Item>
            <Command.Item onSelect={() => handleSelect('/customer')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
              <span>🏢 View Customers</span>
              <span className="text-xs text-gray-400 font-normal">/customer</span>
            </Command.Item>
            <Command.Item onSelect={() => handleSelect('/lead/lead/report')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
              <span>📈 Today's Lead Report</span>
              <span className="text-xs text-gray-400 font-normal">report</span>
            </Command.Item>
          </Command.Group>

          {/* 2. PRODUCTIVITY & TASKS */}
          <Command.Group heading="Productivity & Tracking" className="text-xs text-emerald-500 dark:text-emerald-400 uppercase font-bold px-2 py-2 border-t border-gray-100 dark:border-gray-700 mt-2">
            <Command.Item onSelect={() => handleSelect('/tasks')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
              <span>✅ General Tasks</span>
              <span className="text-xs text-gray-400 font-normal">/tasks</span>
            </Command.Item>
            <Command.Item onSelect={() => handleSelect('/lead-tasks')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
              <span>🎯 Lead Specific Tasks</span>
              <span className="text-xs text-gray-400 font-normal">/lead-tasks</span>
            </Command.Item>
            <Command.Item onSelect={() => handleSelect('/issues')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
              <span>⚠️ Technical Issues</span>
              <span className="text-xs text-gray-400 font-normal">/issues</span>
            </Command.Item>
            <Command.Item onSelect={() => handleSelect('/todo')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
              <span>📝 Personal To-Do List</span>
              <span className="text-xs text-gray-400 font-normal">/todo</span>
            </Command.Item>
            <Command.Item onSelect={() => handleSelect('/calendar')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
              <span>📅 Event Calendar</span>
              <span className="text-xs text-gray-400 font-normal">/calendar</span>
            </Command.Item>
            <Command.Item onSelect={() => handleSelect('/meeting')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
              <span>🤝 Schedule Meetings</span>
              <span className="text-xs text-gray-400 font-normal">/meeting</span>
            </Command.Item>
          </Command.Group>

          {/* 3. CHAT & WHATSAPP ENGINE */}
          <Command.Group heading="Communications & Messaging" className="text-xs text-teal-500 dark:text-teal-400 uppercase font-bold px-2 py-2 border-t border-gray-100 dark:border-gray-700 mt-2">
            <Command.Item onSelect={() => handleSelect('/chat')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
              <span>💬 Live Chat Room</span>
              <span className="text-xs text-gray-400 font-normal">/chat</span>
            </Command.Item>
            <Command.Item onSelect={() => handleSelect('/whatsappSms')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
              <span>🟢 WhatsApp Bulk SMS</span>
              <span className="text-xs text-gray-400 font-normal">/whatsappSms</span>
            </Command.Item>
            <Command.Item onSelect={() => handleSelect('/auto-reply')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
              <span>🤖 WhatsApp Auto Reply Rules</span>
              <span className="text-xs text-gray-400 font-normal">/auto-reply</span>
            </Command.Item>
            <Command.Item onSelect={() => handleSelect('/whatsappReport')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
              <span>📊 WhatsApp Delivery Reports</span>
              <span className="text-xs text-gray-400 font-normal">/whatsappReport</span>
            </Command.Item>
            <Command.Item onSelect={() => handleSelect('/createWhatsappTemplate')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
              <span>✨ Create WhatsApp Template</span>
              <span className="text-xs text-gray-400 font-normal">template</span>
            </Command.Item>
          </Command.Group>

          {/* 4. HR & ATTENDANCE */}
          <Command.Group heading="HR & Attendance" className="text-xs text-amber-500 dark:text-amber-400 uppercase font-bold px-2 py-2 border-t border-gray-100 dark:border-gray-700 mt-2">
            <Command.Item onSelect={() => handleSelect('/attendance')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
              <span>📅 Attendance Log</span>
              <span className="text-xs text-gray-400 font-normal">/attendance</span>
            </Command.Item>
            <Command.Item onSelect={() => handleSelect('/leave')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
              <span>🚪 Leave Management</span>
              <span className="text-xs text-gray-400 font-normal">/leave</span>
            </Command.Item>
            <Command.Item onSelect={() => handleSelect('/workingPolicy')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
              <span>📜 Company Working Policy</span>
              <span className="text-xs text-gray-400 font-normal">/workingPolicy</span>
            </Command.Item>
          </Command.Group>

          {/* 5. ACCOUNTS & INVOICES */}
          <Command.Group heading="Accounts & Billing" className="text-xs text-rose-500 dark:text-rose-400 uppercase font-bold px-2 py-2 border-t border-gray-100 dark:border-gray-700 mt-2">
            <Command.Item onSelect={() => handleSelect('/invoice')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
              <span>🧾 Generate Invoices</span>
              <span className="text-xs text-gray-400 font-normal">/invoice</span>
            </Command.Item>
            <Command.Item onSelect={() => handleSelect('/accountStatement')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
              <span>💳 Account Statements</span>
              <span className="text-xs text-gray-400 font-normal">/accountStatement</span>
            </Command.Item>
            <Command.Item onSelect={() => handleSelect('/viewAccount')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
              <span>🏢 View Sub-Accounts</span>
              <span className="text-xs text-gray-400 font-normal">/viewAccount</span>
            </Command.Item>
          </Command.Group>

          {/* 6. SYSTEM SETTINGS & INTEGRATIONS */}
          <Command.Group heading="Settings & Integrations" className="text-xs text-gray-400 uppercase font-bold px-2 py-2 border-t border-gray-100 dark:border-gray-700 mt-2">
            <Command.Item onSelect={() => handleSelect('/profile')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
              <span>⚙️ Profile Settings</span>
              <span className="text-xs text-gray-400 font-normal">/profile</span>
            </Command.Item>
            <Command.Item onSelect={() => handleSelect('/whatsappConfig')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
              <span>🔧 WhatsApp API Integration</span>
              <span className="text-xs text-gray-400 font-normal">/whatsappConfig</span>
            </Command.Item>
            <Command.Item onSelect={() => handleSelect('/smsConfig')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
              <span>💬 Bulk SMS Configuration</span>
              <span className="text-xs text-gray-400 font-normal">/smsConfig</span>
            </Command.Item>
            <Command.Item onSelect={() => handleSelect('/ivrIntegration')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
              <span>📞 IVR Calling Integration</span>
              <span className="text-xs text-gray-400 font-normal">/ivrIntegration</span>
            </Command.Item>
            <Command.Item onSelect={() => handleSelect('/facebookIntegration')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
              <span>🔵 Facebook Lead Ads Sync</span>
              <span className="text-xs text-gray-400 font-normal">/facebookIntegration</span>
            </Command.Item>
            <Command.Item onSelect={() => handleSelect('/googleForm')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
              <span>📝 Google Form Integration</span>
              <span className="text-xs text-gray-400 font-normal">/googleForm</span>
            </Command.Item>
            <Command.Item onSelect={() => handleSelect('/webSetting')} className="p-3 mb-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-800 dark:text-gray-200 flex justify-between items-center transition-colors">
              <span>🌐 Web CRM Custom Settings</span>
              <span className="text-xs text-gray-400 font-normal">/webSetting</span>
            </Command.Item>
          </Command.Group>
        </Command.List>

      </div>
    </Command.Dialog>
  );
};

export default CommandMenu;